import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'



import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)

import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
Vue.use(Viewer)
    // 基础设置
Viewer.setDefaults({
        Options: {
            'inline': true,
            'button': true,
            'navbar': true,
            'title': true,
            'toolbar': true,
            'tooltip': true,
            'movable': true,
            'zoomable': true,
            'rotatable': true,
            'scalable': true,
            'transition': true,
            'fullscreen': true,
            'keyboard': true,
            'url': 'data-original'
        }
    })
    // 修改配置
Viewer.setDefaults({ 'navbar': false, 'toolbar': false, 'url': 'data-original' })


import "./assets/style/font-awesome-4.7.0/css/font-awesome.css";
import './assets/style/font-awesome-4.7.0/css/font-awesome.min.css';
import './assets/style/normalize.css'
import "@/assets/font/font.css"

import smoothscroll from 'smoothscroll-polyfill';
smoothscroll.polyfill();
Vue.prototype.$axios = axios
Vue.config.productionTip = false

new Vue({
    router,
    store,

    render: function(h) { return h(App) }
}).$mount('#app')